export function asError(thrown: unknown, unknownErrorMessage?: string): Error {
    return thrown instanceof Error
        ? thrown
        : typeof thrown === "string"
        ? new Error(thrown)
        : typeof thrown === "object" && thrown !== null && "message" in thrown
        ? new Error((thrown as any).message)
        : new Error(unknownErrorMessage ?? `unknown error: ${thrown}`)
}

export function getSignupError(thrown: unknown): {
    displayType: "toast" | "inline"
    message: string
} {
    const error = asError(thrown, "Could not sign up")

    return error.message.toLowerCase().includes("not a work e-mail")
        ? { displayType: "inline", message: "Please use a work email address" }
        : { displayType: "toast", message: error.message }
}
